import { isGridApiReady, type UseBlotterTableProps } from '@talos/kyoko';
import type { GridApi } from 'ag-grid-community';
import { noop } from 'lodash-es';
import { useCallback } from 'react';
import type { PriceGridLadderColumnConfig } from '../columns/priceGridMarketDataQtyColumns';
import { isPriceLadderMode } from '../ladder';
import type { PriceGridEntity } from '../PriceGridEntity';

export const PRICE_GRID_QUANTITY_COLUMN_ID = 'Quantity';

type CustomColumnUpdate = NonNullable<UseBlotterTableProps<PriceGridEntity>['customColumnUpdate']>;

export function applyPriceGridQuantityColumnVisibility(
  api: GridApi<PriceGridEntity>,
  ladderConfig: PriceGridLadderColumnConfig
) {
  if (!isGridApiReady(api) || !api.getColumn(PRICE_GRID_QUANTITY_COLUMN_ID)) {
    return;
  }

  api.applyColumnState({
    state: [{ colId: PRICE_GRID_QUANTITY_COLUMN_ID, hide: isPriceLadderMode(ladderConfig.ladderType) }],
  });
}

export function usePriceGridQuantityColumnVisibility(ladderConfig: PriceGridLadderColumnConfig): CustomColumnUpdate {
  return useCallback<CustomColumnUpdate>(
    ({ api }) => {
      if (!isGridApiReady(api)) {
        return noop;
      }

      applyPriceGridQuantityColumnVisibility(api, ladderConfig);
      return noop;
    },
    [ladderConfig]
  );
}
